module.exports = __webpack_public_path__ + "img/livepeer.eace07e3.png";